import React from "react";
import logo from "../assets/images/logo.png";
import specials1 from "../assets/images/specials-1.png";
import specials2 from "../assets/images/specials-2.png";
import specials3 from "../assets/images/specials-3.png";

const productsData = {
  "Top Products": [
    { id: 1, img: specials1, title: "Rotator Tube Revolver for sample tubes", price: "€17.60" },
    { id: 2, img: specials2, title: "Rotator Tube Revolver for sample tubes", price: "€17.60" },
    { id: 3, img: specials3, title: "Rotator Tube Revolver for sample tubes", price: "€17.60" },
  ],
  "New Products": [
    { id: 4, img: specials1, title: "Rotator Tube Revolver for sample tubes", price: "€17.60" },
    { id: 5, img: specials2, title: "Rotator Tube Revolver for sample tubes", price: "€17.60" },
    { id: 6, img: specials3, title: "Rotator Tube Revolver for sample tubes", price: "€17.60" },
  ],
  "Best Sellers": [
    { id: 7, img: specials1, title: "Rotator Tube Revolver for sample tubes", price: "€17.60" },
    { id: 8, img: specials2, title: "Rotator Tube Revolver for sample tubes", price: "€17.60" },
    { id: 9, img: specials3, title: "Rotator Tube Revolver for sample tubes", price: "€17.60" },
  ],
};

function Specials() {
  return (
    <section id="actuall-special-wrapper" className="py-5">
      <div className="container">
        {/* Title */}
        <h2>
          <div className="inner-logo">
            <img src={logo} alt="Logo" />
          </div>
          Specials
        </h2>

        {/* Bootstrap Tabs */}
        <div className="spectail-tab">
        <ul className="nav nav-tabs" id="specialsTab" role="tablist">
          {Object.keys(productsData).map((tab, index) => (
            <li className="nav-item" role="presentation" key={tab}>
              <button
                className={`nav-link ${index === 0 ? "active" : ""}`}
                id={`${tab.replace(/\s+/g, "")}-tab`}
                data-bs-toggle="tab"
                data-bs-target={`#${tab.replace(/\s+/g, "")}`}
                type="button"
                role="tab"
              >
                {tab}
              </button>
            </li>
          ))}
        </ul>
        </div>

        {/* Tab Content */}
        <div className="tab-content mt-4" id="specialsTabContent">
          {Object.entries(productsData).map(([tab, products], index) => (
            <div
              key={tab}
              className={`tab-pane fade ${index === 0 ? "show active" : ""}`}
              id={tab.replace(/\s+/g, "")}
              role="tabpanel"
            >
              <div className="actuall-special-content">
                {products.map((product) => (
                  <div className="col-md-4 actuall-special-box" key={product.id}>
                   
                      <div className="heart-icon"></div>
                      <div className="actuall-img-box">
                      <a href="#">
                        <img
                          src={product.img}
                          alt={product.title}
                          className="card-img-top"
                        />
                      </a>
                      </div>
                     
                        <h3>{product.title}</h3>
                        <h4>
                          from <span>{product.price}</span>
                        </h4>

                        {/* Quantity Selector */}
                       <div className="quantity-selector">
                        <button className="quantity-btn">+</button>
                        <div className="quantity-value">2</div>
                        <button className="quantity-btn">-</button>
                      </div>

                        <a href="#" className="add-to-cart">
                          Add to Cart
                        </a>
                      







                    
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Specials;
